export const skinColors = {
  "FITZ-1": {
    BaseSkin: "#ffd0ba",
    LightSkin: "#ffdccc",
    DarkSkin: "#f1af90",
    AdditionalSkin: "#885031",
    TearsSkin: "#9dbce0"
  },
  "FITZ-2": {
    BaseSkin: "#f6bd9d",
    LightSkin: "#ffcaac",
    DarkSkin: "#e7a580",
    AdditionalSkin: "#774325",
    TearsSkin: "#99b3d3"
  },
  "FITZ-3": {
    BaseSkin: "#e69f73",
    LightSkin: "#f4b38b",
    DarkSkin: "#ce895f",
    AdditionalSkin: "#71442b",
    TearsSkin: "#8495a9"
  },
  "FITZ-4": {
    BaseSkin: "#bb7e53",
    LightSkin: "#ce8e60",
    DarkSkin: "#94623f",
    AdditionalSkin: "#4e3727",
    TearsSkin: "#a1b2cb"
  },
  "FITZ-5": {
    BaseSkin: "#8a502e",
    LightSkin: "#a16847",
    DarkSkin: "#6d4127",
    AdditionalSkin: "#3c2b1f",
    TearsSkin: "#86a6cd"
  },
  "FITZ-6": {
    BaseSkin: "#49321f",
    LightSkin: "#624631",
    DarkSkin: "#231b14",
    AdditionalSkin: "#000000",
    TearsSkin: "#6286b1"
  }
};

export const dress = {
  FROG: ["FrogShadow", "FrogLight", "FrogBase"],
  BEAR: ["BearShadow", "BearLight", "BearBase"],
  BODY: ["BodyShadow", "BodyLight", "BodyBase", "BodyDots"],
  PAJAMAS: ["PajamasShadow", "PajamasLight", "PajamasBase", "PajamasDots"],
  FROG_NAPPY: ["FrogNappyLight", "FrogNappyShadow", "FrogNappyBase"],
  BEAR_NAPPY: ["BearNappyLight", "BearNappyShadow", "BearNappyBase"],
  NAPPY: ["NappyLight", "NappyShadow", "NappyBase", "NappyDots"]
};

export const accessories = {
  FROG_CAP: ["FrogCapShadow", "FrogCapLight", "FrogCapBase"],
  BEAR_CAP: ["BearCapShadow", "BearCapLight", "BearCapBase"],
  CAP: ["CapLight", "CapBase"],
  BOW: ["BowShadow", "BowBase"],
  HEADDRESS: ["HairdressShadow", "HairdressLight", "HairdressBase"],
  NO_ACCESSORY: ["none"]
};

export const hairs = {
  HAIR_0: ["Hair0Base"],
  HAIR_1: ["Hair1Base"],
  HAIR_2: ["Hair2Base"],
  HAIR_3: ["Hair3Base", "Hair3Shadow", "Hair3Light"],
  HAIR_4: ["Hair4Base", "Hair4Shadow", "Hair4Light"],
  NO_HAIR: ["none"]
};

export const noses = {
  NOSE_0: ["Nose0Base"],
  NOSE_1: ["Nose1Base"],
  NOSE_2: ["Nose2Base"]
};

export const cheeks = {
  NO_CHEEK: ["none"],
  CHEEK_0: ["Cheeks0Base"],
  CHEEK_1: ["Cheeks1Base"],
  CHEEK_2: ["Cheeks2Base"]
};

export const eyes = {
  EYE_0: ["Eyes0Base"],
  EYE_1: ["Eyes1Base"],
  EYE_2: ["Eyes2Base"]
};

export const dressColors = [
  "#2aa598",
  "#4192dc",
  "#fa48ad",
  "#f08e33",
  "#ffcc3f",
  "#98d667",
  "#b9d3ff",
  "#bfb2e5",
  "#ffbbe1",
  "#e4e4e4",
  "#858a93",
  "#5d5546"
];

export const dressDotsColors = [
  ["#e4e4e4", "#5f99dc"],
  ["#e4e4e4", "#e07bb4"],
  ["#2aa598", "#bfe4e0"],
  ["#98d667", "#68a13b"],
  ["#f08e33", "#df7513"]
];

export const hairColors = [
  "#000000",
  "#4e3727",
  "#885031",
  "#f28016",
  "#ffe293"
];

export const singleColorsEnum = {
  "#bfb2e5": "VIOLET",
  "#fa48ad": "DARK_PINK",
  "#ffbbe1": "PINK",
  "#f08e33": "ORANGE",
  "#ffcc3f": "YELLOW",
  "#98d667": "GREEN",
  "#2aa598": "DARK_GREEN",
  "#b9d3ff": "LIGHT_BLUE",
  "#4192dc": "BLUE",
  "#858a93": "GRAY",
  "#5d5546": "DARK_GRAY",
  "#e4e4e4": "LIGHT_GRAY"
};

export const dualColorsEnum = {
  "#5f99dc": "WHITE_WITH_BLUE",
  "#e07bb4": "WHITE_WITH_DARK_PINK",
  "#2aa598": "DARK_GREEN_WITH_LIGHT_GREEN",
  "#68a13b": "GREEN_WITH_DARK_GREEN",
  "#df7513": "ORANGE_WITH_DARK_ORANGE"
};

export const hairColorsEnum = {
  "#000000": "BRUNETTE",
  "#4e3727": "DARK_BROWN",
  "#885031": "BROWN",
  "#f28016": "GINGER",
  "#ffe293": "BLOND"
};
